import EnlilAxios from "../../../../util/EnlilAxios";
import {V1BillSubscriptionIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import EventBus from "../../../../util/EventBus";


class BillSubscriptionEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        EnlilAxios({
            method: "GET",
            url: "t2/v1/bill_configurations",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                //"Sort": this.getFormattedSortSpecification(),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.BillConfiguration-002",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1BillSubscriptionIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.BillConfiguration-002";
        payload.ShifamedMessage.BillConfiguration = {
            "USID": this.getEnterpriseObject().getEnterpriseComponent("BillConfiguration").getAttributeValue("USID"),
            "BillSubscription": this.preparePUTPayload()
        };

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t2/v1/bill_configurations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.BillConfiguration-002",
                "idoc-response": "v1.BillConfiguration-002",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1BillSubscriptionIDOCToArray(response.data));
            })
            .catch(error => {
                if (error.response.status === 400 && error.response.data.Code === "CC-DKIE-09ID") {
                    let args = []
                    args.push(error.response.data.Code)
                    args.push(error.response.data.Link)

                    EventBus.error.emit("bill-subscription-error", args);
                } else {
                    this.updateEnterpriseComponentFailed(error);
                }
            });
    };
}

export default BillSubscriptionEnterpriseComponent;